import { render } from "./Contact.vue?vue&type=template&id=4cf021ee"
const script = {}

import "./Contact.vue?vue&type=style&index=0&id=4cf021ee&lang=css"

import exportComponent from "C:\\Users\\ATL\\Desktop\\Dev\\p2-osavus\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__